<template>
  <component
      :is="componentName"
      :filter-element="filterElement"
  ></component>
</template>

<script lang="ts">
  import Vue from "vue";
  import ListViewFilterPropertyDropdown from "./list-view-filter-property-dropdown.vue";
  import ListViewFilterAccountDropdown from "./list-view-filter-account-dropdown.vue";
  import filterElementBaseMixin from "~/mixins/listViews/filterElementBaseMixin";
  import ObjectModelProperty from "~/models/objectModelProperties/objectModelProperty";

  export default Vue.extend({
    mixins: [
      filterElementBaseMixin,
    ],
    components: {
      ListViewFilterPropertyDropdown,
      ListViewFilterAccountDropdown,
    },
    computed: {
      componentName(): string {
        if (this.filterElement.propertyToFilter instanceof ObjectModelProperty) {
          return 'ListViewFilterPropertyDropdown';
        } else {
          return 'ListViewFilterAccountDropdown';
        }
      },
    }
  });
</script>